import { SortBy } from '../models/SortOrder';

// uuid v5 namespaces
export const SEARCH_NAMESPACE = 'fd1db410-c8d9-42d6-90c8-3a45f41fd50e';

// password policy
export const PASSWORD_MIN_LENGTH = 12;

// maps tanstack table column ids to sortKeys
export const SORT_BY_FOR_COLUMN: Record<string, SortBy> = {
  'action-date': SortBy.RECENT_ACTIVITY,
  id: SortBy.ALPHANUMERICAL,
  name: SortBy.BILL_TITLE,
  status: SortBy.BILL_STATUS,
  session: SortBy.BILL_SESSION,
  hearings: SortBy.UPCOMING_HEARINGS,
  tags: SortBy.USER_TAGGED,
  democrats: SortBy.DEM_SPONSOR_COUNT,
  republican: SortBy.REP_SPONSOR_COUNT,
};

export const BILL_TABLE_HEADERS = {
  tracking: 'Tracking',
  tags: 'Tags',
  position: 'Position',
  id: 'Bill ID',
  name: 'Bill Title',
  sponsors: 'Bill Sponsors',
  democrats: '(D)',
  republican: '(R)',
  status: 'Bill Status',
  session: 'Session',
  'action-description': 'Latest Action',
  'action-date': 'Action Date',
  hearings: 'Upcoming Hearing',
  'key-action': 'Latest Key Action',
};

export const CUSTOM_FIELD_RICH_TEXT_CHAR_LIMIT = 1000;

export const isProd = process.env.REACT_APP_ENV?.toLowerCase() === 'prod';
